import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";
import {
  FaShoppingCart,
  FaHome,
  FaBuilding,
  FaMapMarkerAlt,
} from "react-icons/fa";

export default function CheckoutPage() {
  const [errors, setErrors] = useState({});

  const [addresses, setAddresses] = useState([]);
  const [deliveryCharge, setDeliveryCharge] = useState(0);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [cartItems, setCartItems] = useState([]);
  const [addressType, setAddressType] = useState("");
  const [isPlacingOrder, setIsPlacingOrder] = useState(false);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("user")) || null;
  const userId = user?.user_id || null;
  const now = new Date();
  const istOffset = 330 * 60 * 1000; // 5:30
  const istTime = new Date(now.getTime() + istOffset);

  const [form, setForm] = useState({
    name: "",
    email: "",
    address: "",
    landmark: "",
    phonenumber: "",
    pincode: "",
    city: "",
    district: "",
    state: "",
  });



  const openEditAddress = (addr) => {
    setAddressType(addr.label);
    setIsEditing(true);
    setForm(addr);
    setShowForm(true);
  };



  useEffect(() => {
    const initCheckout = async () => {
      const cart = JSON.parse(localStorage.getItem("cart")) || [];
      console.log("=====cart is ========", cart);
      setCartItems(cart);

      if (!userId) {
        localStorage.setItem("redirectAfterLogin", location.pathname);
        navigate("/login", { replace: true });
        return;
      }

      // await fetchUserAddress();
      await fetchUserAddress(cart); // ✅ pass cart here
      setIsPageLoading(false); // ✅ STOP LOADER
    };

    initCheckout();
  }, [userId]);

  // ✅ DERIVED SELECTED ADDRESS (SINGLE SOURCE OF TRUTH)
  const selectedAddress = addresses.find(
    (a) => a.address_id === selectedAddressId
  );

  // const deliveryCharge = Number(localStorage.getItem("delivery_charge") || 0);



  // const fetchUserAddress = async () => {
  const fetchUserAddress = async (cart) => {
    try {
      const res = await fetch(`${API_BASE_URL}addresslist.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id: userId }),
      });

      const data = await res.json();
      const findSubtotal = cart.reduce((sum, item) => sum + (Number(item.price) * (item.quantity || 1)), 0);


      if (data?.head?.code === 200) {
        // const deliveryCharge = Number(localStorage.getItem("delivery_charge") || 0);
        setAddresses(data.body || []);
        if (data.body.length > 0) {
          setSelectedAddressId(data.body[0].address_id); // auto-select first
          // const findDeliverycharge = findSubtotal * Number(data.body[0].delivery_charge) / 100;
          // console.log("======= Delivery Charge:", findDeliverycharge , findSubtotal, data.body[0].delivery_charge);
          // setDeliveryCharge(findDeliverycharge);
          // setDeliveryCharge(data.body[0].delivery_charge);
          setDeliveryCharge(Number(data.body[0].delivery_charge));
        }
      }
    } catch (err) {
      console.error("Address fetch error", err);
    }
  };

  const hasHardcopyItem = cartItems.some((item) => item.type === "Hardcopy");

   const getTotal = () =>
    cartItems.reduce(
      (acc, item) => acc + Number(item.price) * (item.quantity || 1),
      0
    );

  const appliedDeliveryCharge = hasHardcopyItem ? Number(getTotal() * deliveryCharge/100) : 0;

 

  const totalGST = cartItems.reduce((acc, item) => {
    const taxPercent = Number(item.tax || 0); // from localStorage
    const itemTotal = item.price * (item.quantity || 1);
    return acc + (itemTotal * taxPercent) / 100;
  }, 0);

  const CGST = +(totalGST / 2).toFixed(2);
  const SGST = +(totalGST / 2).toFixed(2);

  const grandTotal =
    getTotal() + CGST + SGST + (hasHardcopyItem ? Number(getTotal() * deliveryCharge/100) : 0);

  // Auto-fill location from pincode
  useEffect(() => {
    const fetchLocation = async () => {
      if (/^\d{6}$/.test(form.pincode)) {
        try {
          const res = await fetch(
            `https://api.postalpincode.in/pincode/${form.pincode}`
          );
          const data = await res.json();
          if (data[0].Status === "Success") {
            const postOffice = data[0].PostOffice[0];
            setForm((prev) => ({
              ...prev,
              // city: postOffice.Name || prev.city,
              district: postOffice.District || prev.district,
              state: postOffice.State || prev.state,
            }));
          }
        } catch (err) {
          console.error("Error fetching location:", err);
        }
      }
    };
    fetchLocation();
  }, [form.pincode]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value ?? "",
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

const handleAddressChange = (selectedAddress) => {
  setSelectedAddressId(selectedAddress.address_id);

  if (selectedAddress.state === "Tamil Nadu") {
    setDeliveryCharge(Number(selectedAddress.delivery_charge));
  } else {
    setDeliveryCharge(Number(selectedAddress.delivery_charge_other));
  }
};

  const validateForm = () => {
    const newErrors = {};

    if (!addressType) newErrors.addressType = "Address type is required";
    if (!form.name?.trim()) newErrors.name = "Full name is required";
    if (!form.email?.trim()) newErrors.email = "Email is required";
    if (!form.address?.trim()) newErrors.address = "Address is required";
    if (!form.landmark?.trim()) newErrors.landmark = "Landmark is required";

    if (!form.phonenumber?.trim())
      newErrors.phonenumber = "Phone number is required";
    else if (form.phonenumber.length !== 10)
      newErrors.phonenumber = "Phone number must be 10 digits";

    if (!form.pincode?.trim())
      newErrors.pincode = "Pincode is required";
    else if (form.pincode.length !== 6)
      newErrors.pincode = "Pincode must be 6 digits";

    if (!form.city?.trim()) newErrors.city = "City is required";
    if (!form.district?.trim()) newErrors.district = "District is required";
    if (!form.state?.trim()) newErrors.state = "State is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };



  const handleSaveAddress = async () => {
    if (!validateForm()) return;

    const api = isEditing
      ? "addresslistupdate.php"
      : "addresslistadd.php";

    const payload = {
      user_id: userId,
      label: addressType,
      ...form,
    };

    try {
      const res = await fetch(`${API_BASE_URL}${api}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data?.head?.code === 200) {
        setShowForm(false);
        fetchUserAddress();
      } else {
        alert(data?.head?.msg || "Address save failed");
      }
    } catch (err) {
      console.error(err);
    }
  };




  const handleDeleteAddress = async (address_id) => {
    if (!window.confirm("Delete this address?")) return;

    try {
      const res = await fetch(`${API_BASE_URL}addresslistdelete.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ address_id: address_id, user_id: userId }),
      });

      const data = await res.json();

      if (data?.head?.code === 200) {
        window.location.reload();
        fetchUserAddress();
        if (selectedAddressId === address_id) {
          setSelectedAddressId(null);
        }
      }
    } catch (err) {
      console.error(err);
    }
  };


  const handlePlaceOrder = async () => {
    if (isPlacingOrder) return;

    if (!cartItems.length) {
      alert("Cart is empty");
      return;
    }

    if (!selectedAddress) {
      alert("Select billing address");
      return;
    }

    setIsPlacingOrder(true);

    const billing = selectedAddress;

    /* ---------- 1️⃣ PREPARE ITEMS (CCAvenue Format) ---------- */
    const productdetails = cartItems.map((item) => {
      const qty = item.quantity || 1;
      const price = Number(item.price);
      const taxPercent = Number(item.tax || 0);

      const subtotal = price * qty;
      const taxAmount = (subtotal * taxPercent) / 100;
      const total = subtotal + taxAmount;

      return {
        product_id: item.product_id || item.id,
        main_category_id: item.mpid || "0",
        sub_category_id: item.spid || "0",
        product_name: item.title,
        product_code: item.code,
        image: item.image,
        type: item.type,
        plan: item.plan || "",
        qty: String(qty),
        amount: String(price),
        totalamount: String(total),
        id: item.id,
      };
    });

    /* ---------- 2️⃣ CALCULATE TOTALS ---------- */
    const itemsSubtotal = cartItems.reduce((sum, item) => sum + (Number(item.price) * (item.quantity || 1)), 0);
    const itemsTax = cartItems.reduce((sum, item) => {
      const sub = (Number(item.price) * (item.quantity || 1));
      return sum + (sub * Number(item.tax || 0) / 100);
    }, 0);

    const hasHardcopy = cartItems.some(item => item.type === "Hardcopy");
    const deliveryChargeFinal = hasHardcopy ? appliedDeliveryCharge : 0;
    const finalOrderTotal1 = Math.round(itemsSubtotal + itemsTax + deliveryChargeFinal).toFixed(2);
    const finalOrderTotal = Math.round(finalOrderTotal1).toFixed(2);
    /* ---------- 3️⃣ CONSTRUCT CCAVENUE PAYLOAD ---------- */
    console.log("================", finalOrderTotal);
    console.log("Final Order Total:", finalOrderTotal);
    const payload = {
      user_id: userId,
      billing_details: {
        billing_name: billing.name,
        billing_address: billing.address,
        billing_city: billing.city,
        billing_state: billing.state,
        billing_email: billing.email,
        billing_phonenumber: billing.phonenumber,
        billing_postcode: billing.pincode,
        billing_country: billing.country,
        billing_district: billing.district,
        billing_landmark: billing.landmark
      },
      note: "",
      delivery_charge: String(itemsSubtotal * deliveryChargeFinal/100),
      subtotal: String(itemsSubtotal),
      sgst: String(itemsTax / 2), // Assuming equal split for SGST/CGST
      cgst: String(itemsTax / 2),
      total: String(finalOrderTotal),
      paymentmode: "online",
      productdetails: productdetails
    };
    console.log("=========payload is =============", payload);
    /* ---------- 4️⃣ CALL HANDLER & REDIRECT ---------- */

    try {
      const res = await fetch(`${API_BASE_URL}ccavenue_handler.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const result = await res.json();

      if (result?.head?.code === 200) {

        console.log(result.body);
        const { encRequest, access_code, action_url } = result.body;

        // ✅ Save payload for ThankYou page
        localStorage.setItem(
          "pendingOrderPayload",
          JSON.stringify(payload)
        );

        // Use the helper to submit the hidden form
        redirectToCcavenue(encRequest, access_code, action_url);
      } else {
        alert(result?.head?.msg || "Payment initiation failed");
      }
    } catch (err) {
      console.error("CCAvenue initiation error:", err);
      alert("Server error connecting to payment gateway");
    } finally {
      // setIsPlacingOrder(false);
    }

  };

  /* ---------- HELPER FUNCTION ---------- */
  const redirectToCcavenue = (encRequest, accessCode, actionUrl) => {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = actionUrl;

    const encInput = document.createElement('input');
    encInput.type = 'hidden';
    encInput.name = 'encRequest';
    encInput.value = encRequest;
    form.appendChild(encInput);

    const accessInput = document.createElement('input');
    accessInput.type = 'hidden';
    accessInput.name = 'access_code';
    accessInput.value = accessCode;
    form.appendChild(accessInput);

    document.body.appendChild(form);
    form.submit();
  };

  // Page loader
  const PageLoader = () => {
    return (
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "#ffffff",
          zIndex: 99999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <div
          className="spinner-border"
          role="status"
          style={{ width: "3.5rem", height: "3.5rem", color: "#f64a1aff" }}
        />
        <p className="mt-3 fw-semibold">Loading Checkout Page...</p>
      </div>
    );
  };

  return (
    <> {isPageLoading && <PageLoader />}
      <div className="container py-4">
        <motion.h2
          className="text-center fw-bold mb-4"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          💳 Checkout
        </motion.h2>

        {/* --- BILLING ONLY (UPDATED WITH DELETE + RIGHT SIDE ADDRESS LIST) --- */}
        <div className="card border-0 shadow-sm mb-4">
          <div className="card-header d-flex justify-content-between align-items-center bg-primary text-white">
            <div>
              <FaHome className="me-2" />
              <span className="fw-bold">Billing Address</span>
            </div>

            <button
              className="btn btn-sm btn-light"
              onClick={() => {
                setIsEditing(false);

                setForm([]);
                setShowForm(true);
                // setEditingAddressIndex(null);
                setAddressType("");
              }}
            >
              Add New
            </button>
          </div>

          <div className="card-body">
            <div className="row" style={{ textAlign: "left" }}>
              {/* LEFT SIDE – SELECTED BILLING ADDRESS */}
              <div className="col-lg-4 col-md-6 border-end mx-auto">
                <h6 className="fw-bold mb-2">
                  Selected Billing Address
                </h6>

                {selectedAddress ? (
                  <div className="p-3 rounded bg-primary-subtle">
                    <p className="mb-1 fw-bold">{selectedAddress.name}</p>
                    <p className="mb-1 small">
                      {selectedAddress.address}, {selectedAddress.landmark}
                    </p>
                    <p className="mb-1 small">
                      {selectedAddress.city}, {selectedAddress.district}, {selectedAddress.state}
                    </p>
                    <p className="mb-1 small">
                      {selectedAddress.country} - {selectedAddress.pincode}
                    </p>
                    <p className="mb-0 small">
                      📞 {selectedAddress.phonenumber}
                    </p>
                  </div>
                ) : (
                  <p className="text-muted">No billing address selected</p>
                )}

              </div>

              {/* RIGHT SIDE – SAVED ADDRESS LIST */}
              <div className="col-lg-4 col-md-6 mx-auto">
                <h6 className="fw-bold mb-2 mt-2">Saved Addresses</h6>

                {addresses.length === 0 && (
                  <p className="text-muted">No saved addresses.</p>
                )}

                <div
                  className="row g-2 overflow-auto"
                  style={{ maxHeight: "150px" }}
                >
                  {addresses.map((a) => (
                    <label
                      key={a.address_id}
                      className={`w-100 p-2 rounded border d-flex gap-2 align-items-start ${selectedAddressId === a.address_id
                        ? "border-primary bg-primary-subtle"
                        : ""
                        }`}
                      style={{ cursor: "pointer" }}
                    >
                      <input
                        type="radio"
                        name="address"
                        checked={selectedAddressId === a.address_id}
                        // onChange={() => setSelectedAddressId(a.address_id)}
                          onChange={() => handleAddressChange(a)}
                        className="mt-1"
                      />

                      <div className="flex-grow-1 small">
                        <strong>{a.name}</strong> ({a.label})<br />
                        <span className="text-muted">
                          {a.address},{a.landmark},{a.city},{a.state}-{a.pincode}
                        </span><br />
                        📞 {a.phonenumber}<br />

                      </div>

                      <div className="d-flex gap-1">
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-secondary"
                          onClick={() => openEditAddress(a)}
                        >
                          Edit
                        </button>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => handleDeleteAddress(a.address_id)}
                        >
                          Delete
                        </button>
                      </div>
                    </label>
                  ))}
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* --- CART SECTION (Single Table) --- */}
        <div className="card shadow-sm border-0 mb-4">
          <div className="card-header bg-primary text-white fw-bold">
            <FaShoppingCart className="me-2" /> Shopping Cart
          </div>
          <div className="card-body text-center">
            <div className="table-responsive">
              <table className="table table-bordered border-dark-subtle align-middle text-center">
                <thead className="table-light border-dark-subtle">
                  <tr>
                    <th>Image</th>
                    <th>Product Code</th>
                    <th>Product</th>
                    <th>Qty</th>
                    <th>Unit Price</th>
                    <th>Total</th>
                  </tr>
                </thead>

                <tbody>
                  {/* CART ITEMS */}
                  {cartItems.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="text-center text-muted py-4">
                        Cart is empty.
                      </td>
                    </tr>
                  ) : (
                    cartItems.map((item) => (
                      <tr key={item.id}>
                        <td>
                          <img
                            src={item.image}
                            alt={item.title}
                            style={{
                              width: 70,
                              height: 70,
                              objectFit: "contain",
                            }}
                            className="rounded"
                          />
                        </td>
                        <td>{item.code}</td>
                        <td className="text-start">{item.title}</td>
                        <td>{item.quantity || 1}</td>
                        <td className="text-end">
                          ₹ {Number(item.price).toFixed(2)}
                        </td>
                        <td className="text-end">
                          ₹{" "}
                          {(Number(item.price) * (item.quantity || 1)).toFixed(2)}
                        </td>
                      </tr>
                    ))
                  )}

                  {/* TOTALS INSIDE SAME TABLE */}
                  <tr>
                    <td colSpan="5" className="text-end fw-bold">
                      Sub-Total:
                    </td>
                    <td className="text-end fw-bold">
                      ₹ {getTotal().toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="5" className="text-end">
                      CGST:
                    </td>
                    <td className="text-end">₹ {CGST.toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td colSpan="5" className="text-end">
                      SGST:
                    </td>
                    <td className="text-end">₹ {SGST.toFixed(2)}</td>
                  </tr>
                  {hasHardcopyItem && (
                    <tr>
                      <td colSpan="5" className="text-end">
                        Delivery Charge:
                      </td>
                      <td className="text-end">₹ {Number(getTotal().toFixed(2) *deliveryCharge/100)}</td>
                    </tr>
                  )}
                  <tr>
                    <td colSpan="5" className="text-end fw-bold">
                      Total:
                    </td>
                    <td className="text-success text-end fw-bold">
                      ₹ {Math.round(grandTotal).toFixed(2)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-warning fw-bold mt-3 d-flex align-items-center justify-content-center"
                onClick={handlePlaceOrder}
                disabled={isPlacingOrder}
                style={{ minWidth: "180px" }}
              >
                {isPlacingOrder ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Placing Order...
                  </>
                ) : (
                  "Place Order"
                )}
              </button>
            </div>
          </div>
        </div>

        {/* ADDRESS POPUP FORM */}
        {showForm && (
          <div className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-75 d-flex justify-content-center align-items-center">
            <div className="bg-white p-4 rounded shadow-lg col-lg-6 col-md-8 col-sm-11">
              <h5 className="fw-bold text-center mb-3">
                {addressType != ""
                  ? "Edit Address"
                  : "Add New Address"}
              </h5>

              <div className="d-flex justify-content-center gap-3 mb-3">
                <button
                  className={`btn ${addressType === "Home" ? "btn-success" : "btn-outline-success"
                    }`}
                  onClick={() => setAddressType("Home")}
                // disabled={getDisabledTypes().includes("Home")}
                >
                  <FaHome className="me-1" /> Home
                </button>

                <button
                  className={`btn ${addressType === "Office"
                    ? "btn-success"
                    : "btn-outline-success"
                    }`}
                  onClick={() => setAddressType("Office")}
                // disabled={getDisabledTypes().includes("Office")}
                >
                  <FaBuilding className="me-1" /> Office
                </button>

                <button
                  className={`btn ${addressType === "Others"
                    ? "btn-success"
                    : "btn-outline-success"
                    }`}
                  onClick={() => setAddressType("Others")}
                >
                  <FaMapMarkerAlt className="me-1" /> Others
                </button>
              </div>

              {/* FORM FIELDS */}
              <div className="row g-3">
                <div className="col-md-6">
                  <input
                    type="text"
                    name="name"
                    className={`form-control ${errors.name ? "is-invalid" : ""}`}
                    placeholder="Full Name"
                    value={form.name}
                    onChange={handleChange}
                    disabled={!addressType}
                  />
                  {errors.name && <div className="invalid-feedback">{errors.name}</div>}

                </div>

                <div className="col-md-6">
                  <input
                    type="text"
                    name="email"
                    className={`form-control ${errors.email ? "is-invalid" : ""}`}
                    placeholder="Email"
                    value={form.email}
                    onChange={handleChange}
                    disabled={!addressType}
                  />
                  {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                </div>

                <div className="col-12">
                  <input
                    type="text"
                    name="address"
                    className={`form-control ${errors.address ? "is-invalid" : ""}`}
                    placeholder="Address"
                    value={form.address}
                    onChange={handleChange}
                    disabled={!addressType}
                  />
                  {errors.address && <div className="invalid-feedback">{errors.address}</div>}
                </div>

                <div className="col-12">
                  <input
                    type="text"
                    name="landmark"
                    className={`form-control ${errors.landmark ? "is-invalid" : ""}`}
                    placeholder="Landmark"
                    value={form.landmark}
                    onChange={handleChange}
                    disabled={!addressType}
                  />
                  {errors.landmark && <div className="invalid-feedback">{errors.landmark}</div>}
                </div>

                <div className="col-md-6">
                  <input
                    type="text"
                    name="phonenumber"
                    className={`form-control ${errors.phonenumber ? "is-invalid" : ""}`}
                    placeholder="Phone"
                    value={form.phonenumber}
                    onChange={handleChange}
                    disabled={!addressType}
                    maxLength={10}
                  />
                  {errors.phonenumber && <div className="invalid-feedback">{errors.phonenumber}</div>}
                </div>

                <div className="col-md-6">
                  <input
                    type="text"
                    name="pincode"
                    className={`form-control ${errors.pincode ? "is-invalid" : ""}`}
                    placeholder="Pincode"
                    value={form.pincode}
                    onChange={handleChange}
                    disabled={!addressType}
                    maxLength={6}
                  />
                  {errors.pincode && <div className="invalid-feedback">{errors.pincode}</div>}
                </div>

                <div className="col-md-4">
                  <input
                    type="text"
                    name="city"
                    className={`form-control ${errors.city ? "is-invalid" : ""}`}
                    value={form.city}
                    placeholder="City"
                    onChange={handleChange}
                    disabled={!addressType}
                  />
                  {errors.city && <div className="invalid-feedback">{errors.city}</div>}
                </div>
                <div className="col-md-4">
                  <input
                    type="text"
                    className="form-control"
                    // className={`form-control ${errors.district ? "is-invalid" : ""}`}
                    value={form.district}
                    placeholder="District"
                    readOnly
                  />
                  {/* {errors.district && <div className="invalid-feedback">{errors.district}</div>} */}
                </div>
                <div className="col-md-4">
                  <input
                    type="text"
                    className="form-control"
                    // className={`form-control ${errors.state ? "is-invalid" : ""}`}
                    value={form.state}
                    placeholder="State"
                    readOnly
                  />
                  {/* {errors.state && <div className="invalid-feedback">{errors.state}</div>} */}

                </div>

                <div className="text-end mt-3">
                  <button
                    className="btn btn-secondary me-2"
                    onClick={() => setShowForm(false)}
                  >
                    Cancel
                  </button>
                  <button className="btn btn-primary" onClick={handleSaveAddress}>
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
